<span class="fm-snackbar">
  {{msg}}
  <button *ngIf="isDismissable"
          mat-raised-button
          size=""
          color="accent"
          style="font-size: 9px; line-height: 18px;position:absolute; top:0; right:0; bottom: "
          (click)="snackBarRef.dismiss()">X</button>
</span>
